<template>
  <div>
    <el-card shadow="always" style="box-shadow:none">
      <EditForm
        ref="editForm"
        :evgCombineCode="evgCombineCode"
        :evgCombineStatus.sync="evgCombineStatus"
        :optType="pageType"
        @reload="reload"
      />
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'ecom-base-evgGoodsCombine-detail',
  components: { EditForm },
  data() {
    return { evgCombineStatus: '' }
  },
  computed: {
    params() {
      return this.$route.params
    },
    // params() {
    //   return this.evgCombineStatus == 'Y'
    // },
    pageType() {
      return this.params.pageType
    },
    evgCombineCode() {
      return this.params.evgCombineCode
    },
  },
  methods: {
    reload() {
      this.$refs.skuTable.getData()
    },
  },
}
</script>
